import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChartColumn } from 'react-icons/fa6';

/**
 * EmptyState sub-component
 * Shows message when no violin plots are available
 */
export const EmptyState: React.FC = memo(() => {
  const { t } = useTranslation('training');

  return (
    <div className="mt-6 sm:mt-8 rounded-xl border border-border bg-card overflow-hidden shadow-sm">
      <div className="flex flex-col items-center justify-center py-14 sm:py-18 px-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-4">
          <FaChartColumn className="text-muted-foreground text-base" />
        </div>
        <h3 className="text-sm sm:text-base font-semibold text-foreground mb-1.5 tracking-tight">
          {t('training.visualization.noData')}
        </h3>
        <p className="text-xs sm:text-sm text-muted-foreground text-center max-w-sm leading-relaxed">
          {t('training.visualization.noDataDescription')}
        </p>
      </div>
    </div>
  );
});

EmptyState.displayName = 'EmptyState';

export default EmptyState;
